import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SideBarComponent } from '../side-bar-component/side-bar-component';
import { FooterComponent } from '../footer-component/footer-component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Store } from '@ngxs/store';
import { LoadingState } from '../../../core/loading.state';

@Component({
  selector: 'app-billytics-public-container-component',
  imports: [MatSidenavModule, SideBarComponent, FooterComponent, MatProgressBarModule],
  templateUrl: './billytics-public-container-component.html',
  styleUrl: './billytics-public-container-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillyticsPublicContainerComponent {
  #store = inject(Store);
  loading$ = this.#store.selectSignal(LoadingState.loadingAll);
}
